import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Form, Input, Button } from 'antd';
import { makeStyles } from '@material-ui/styles';
import { useApolloClient } from '@apollo/client';
import generatePath from '~client/settings/routing';
import { MUTATION_AGENTFORGETPASSWORD } from './queries';
import { useHistory } from 'react-router-dom';
const useStyles = makeStyles(theme => ({
  wrapper: {},
  title: {
    ...theme.typography.h1,
    margin: '12px 0',
    color: theme.colors.gray9,
  },
  subTitle: {
    fontSize: 14,
    lineHeight: '22px',
    color: theme.colors.gray7,
    marginBottom: 40,
  },
  mainForm: {
    '& .ant-form-item': {
      marginBottom: 20,

      '& input': {
        fontSize: 14,
      },
    },
  },
  btnSubmit: {
    ...theme.typography.h5,
    marginBottom: 12,
  },
  btnBack: {
    width: '100%',
    textAlign: 'center',
    fontSize: 14,
    lineHeight: '22px',
    padding: '9px 0',

    '& a:hover': {
      color: theme.colors.mainGreen6,
    },
  },
}));

const SendAgentSetLink = ({ form, match }) => {
  const client = useApolloClient();
  let history = useHistory();
  const { getFieldDecorator, validateFields } = form;

  const classes = useStyles();

  const { t } = useTranslation();

  const handleResetPassword = e => {
    e.preventDefault();
    validateFields((err, values) => {
      // TODO change the portal's value to 'AGENT'
      // TODO onError
      if (!err) {
        client
          .mutate({
            mutation: MUTATION_AGENTFORGETPASSWORD,
            variables: {
              email: values.email,
              portal: 'AGENT',
            },
          })
          .then(response => {
            if (response?.data?.forgotPassword?.success) {
              history.push(
                generatePath('resetAgentPasswordSuccess', { email: match.params.email }),
              );
            }
          })
          .catch(e => {});
      }
    });
  };

  return (
    <div className={classes.wrapper}>
      <h1 className={classes.title}>{t('landlord.reset_password.main.title')}</h1>
      <h2 className={classes.subTitle}>{t('landlord.reset_password.main.heading')}</h2>

      <Form onSubmit={handleResetPassword} className={classes.mainForm}>
        <Form.Item className="auth__forget-email">
          {getFieldDecorator('email', {
            validateTrigger: 'onBlur',
            initialValue: match.params.email ? decodeURIComponent(match.params.email) : '',
          })(
            <Input
              disabled
              size="large"
              placeholder={t('landlord.log_in.main.email.placeholder')}
            />,
          )}
        </Form.Item>

        <Button block type="primary" size="large" htmlType="submit" className={classes.btnSubmit}>
          {t('landlord.reset_password.main.button.reset')}
        </Button>

        <div className={classes.btnBack}>
          <Link to={generatePath('agentLogin')} className="auth__main__back">
            {t('landlord.auth.main.button.back')}
          </Link>
        </div>
      </Form>
    </div>
  );
};

SendAgentSetLink.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      email: PropTypes.string,
    }),
  }),
  form: PropTypes.shape({
    getFieldDecorator: PropTypes.func.isRequired,
    validateFields: PropTypes.func.isRequired,
  }),
};

SendAgentSetLink.defaultProps = {
  match: {
    params: {
      email: '',
    },
  },
  form: PropTypes.shape({
    getFieldDecorator: () => {},
    validateFields: () => {},
  }),
};

export default Form.create({
  name: 'SendAgentSetLink',
})(SendAgentSetLink);
